export default {
    status: {
        acknowledged: "Objednané",
        created: "Vytvořeno",
        sent: "Objednané",
        confirmed: "Objednané",
        not_confirmed: "Neobjednáno",
        delivery_email: "Odesláno",
        delivery_rejected: "Výjimka doručení",
        delivery_rejected_not_confirmed: "Výjimka doručení",
        shipped: "Odesláno",
        delayed: "Zpožděno",
        preparing: "Příprava",
        processing: "Zpracování",
        processed: "Zpracováno",
        submitted: "Objednané",
        delivery_not_received: "Odesláno",
        shipment_exception: "Odesláno",
        pre_pending_approval: "Čeká na vyřízení",
        pending_approval: "Čeká na vyřízení",
        approved: "Schválený",
        not_approved: "Neschváleno",
        canceled: "Zrušeno",
        returned: "Vráceno",
        lost_shipment: "Ztracená zásilka",
        delivery_not_confirmed: "Doručeno",
        delivered: "Doručeno",
        delivery_received: "Doručeno",
        refurbished: "Vrácení dokončeno",
        returned_to_office: "Vrátil se do kanceláře",
        return_to_employer: "Vráceno zaměstnavateli",
        return_pickup_scheduled: "Vyzvednutí naplánováno",
        return_pickup_completed: "Vyzvednutí dokončeno",
        return_pickup_excluded: "Vyzvednutí vyloučeno",
        return_pickup_submitted: "Vyzvednutí odesláno",
        return_pickup_finalized: "Vyzvednutí dokončeno",
        disposed: "Zlikvidováno",
        damaged: "Poškozené",
        transferred: "Převedeno",
        transfer_received: "Převod přijat"
    }
}